import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-method-lluvia',
  templateUrl: './method-lluvia.component.html',
  styleUrls: ['./method-lluvia.component.scss']
})
export class MethodLluviaComponent implements OnInit {

    @Input() data: any;

    @Output() removeMethod = new EventEmitter();
    @Output() updateMethod = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    metodoModal() {
        // console.log('hola');
    }

    remove(data) {
        this.removeMethod.emit(data);
        this.updateMethod.emit(false);
    }
}
